/**
 * This class contains constants used throughout the program for layout, sizing, and default values.
 * It increases readability and makes it easier to adjust these values in one class.
 */

export const NODE_SIDE_LENGTH = 300;
export const GRID_NODE_SIZE = 160;
export const GRID_GAP = 12;
export const AUDIO_NODE_WIDTH = 300;
export const AUDIO_NODE_HEIGHT = 120;
export const IMAGE_NODE_WIDTH = 300;
export const IMAGE_NODE_HEIGHT = 200;

export const HALF = 0.5;
export const ORIGIN = 0;
export const RADIANS_TO_DEGREES = 180 / Math.PI;

export const LINK_SPACING = 16;
export const LINK_WIDTH = 12;
export const LINK_HEIGHT = 5;

export const CANVAS_SIZE = 10000;
export const DEFAULT_COLLECTION_WIDTH = 400;
export const DEFAULT_COLLECTION_HEIGHT = 300;
export const DEFAULT_IMAGE_WIDTH = 400;
export const DEFAULT_IMAGE_HEIGHT = 300;

export const VIEWPORT_CENTER_X = () => window.innerWidth / 2;
export const VIEWPORT_CENTER_Y = () => window.innerHeight / 2;
export const SPAWN_X = () => VIEWPORT_CENTER_X();
export const SPAWN_Y = () => VIEWPORT_CENTER_Y();

export const LINK_ID_LENGTH = 6;

export const DEFAULT_TEXT_TITLE = "New Text Node";
export const DEFAULT_AUDIO_TITLE = "Audio";
export const DEFAULT_IMAGE_URL = 
"https://static0.givemesportimages.com/wordpress/wp-content/uploads/2024/07/mixcollage-27-jul-2024-08-27-pm-2670.jpg";
export const DEFAULT_VIDEO_URL =
  "http://cs.brown.edu/people/peichman/downloads/cted.mp4"; 
export const DEFAULT_WEB_URL = "https://www.wikipedia.org/";
export const DEFAULT_AUDIO_URL =
  "https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3";


export const COLORS = {
    TOP_BAR_BLUE: "#2563eb",
    TOP_BAR_HOVER: "rgba(255, 255, 255, 0.25)",
    TOP_BAR_BUTTON: "rgba(255, 255, 255, 0.15)",

    LINK_ACTIVE: "#ffcc00",
    LINK_ACTIVE_BORDER: "#eab308",
    LINK_COLOR: "#111",

    DELETE_RED: "#ef4444",
    DELETE_RED_HOVER: "#dc2626",

    GRID_BACKGROUND: "#eaeaea",
};
